angular.module('app').directive('campanhaValoresSugeridos', function ($http) {
    return {
        restrict: 'E',
        templateUrl: '/html/campanha-valores-sugeridos.html?v=' + angular.element('meta[name="version-id"]').attr('content'),
        scope: {
            ngModel: '=',
            iniciais: '=',
            valorMinimo: '=',
        },
        controller: function ($scope, $timeout) {

            $scope.onBlur = function (ix) {

                const isDuplicado = $scope.ngModel.filter((item, item_ix) => item_ix !== ix).find(item => item === $scope.ngModel[ix]);

                if (!$scope.ngModel[ix] || $scope.ngModel[ix] === 'R$ 0,00' || ($scope.ngModel[ix].numeroToNumber() < $scope.valorMinimo.numeroToNumber()) || isDuplicado) {
                    $scope.ngModel[ix] = $scope.iniciais[ix].numberToNumero(0).rsPrefix();
                }
            }
        },
        link: function ($scope, $element, attrs, ctrl) {
            if (!$scope.ngModel) {
                $scope.ngModel = $scope.iniciais.map(function (item) {
                    return item.numberToNumero(0).rsPrefix();
                });
            }
        }
    };
})